<template>
  <div class="head">
    <div v-show="backArrow" class="head__back" @click="handleBack">
      <img
        class="head__back__icon"
        src="@/assets/images/icon/back.svg"
        alt="back"
      />
    </div>
    <div class="head__info">
      <div class="head__info__title">
        {{ title }}
      </div>
      <div v-show="account" class="head__info__account">@{{ account }}</div>
      <div v-show="count" class="head__info__count">{{ count }} 推文</div>
    </div>
    <div v-show="message" class="head__message">
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M23.2499 3.25001H20.8249V0.825012C20.8249 0.411012 20.4889 0.0750122 20.0749 0.0750122C19.6609 0.0750122 19.3249 0.411012 19.3249 0.825012V3.25001H16.8999C16.4859 3.25001 16.1499 3.58601 16.1499 4.00001C16.1499 4.41401 16.4859 4.75001 16.8999 4.75001H19.3249V7.17501C19.3249 7.58901 19.6609 7.92501 20.0749 7.92501C20.4889 7.92501 20.8249 7.58901 20.8249 7.17501V4.75001H23.2499C23.6639 4.75001 23.9999 4.41401 23.9999 4.00001C23.9999 3.58601 23.6639 3.25001 23.2499 3.25001ZM20.0749 10.126C19.6609 10.126 19.3249 10.462 19.3249 10.876V18.954C19.3249 19.368 18.9879 19.704 18.5749 19.704H4.09495C3.68295 19.704 3.34495 19.368 3.34495 18.954V8.29801L10.1229 12.816C10.4909 13.062 10.9129 13.186 11.3359 13.186C11.7579 13.186 12.1799 13.062 12.5479 12.816L17.0779 9.80301C17.4139 9.58001 17.5059 9.12701 17.2819 8.79101C17.0589 8.45901 16.6069 8.36601 16.2699 8.59101L11.7399 11.605C11.4939 11.767 11.1769 11.768 10.9319 11.605L3.34595 6.54501V5.50001C3.34595 5.08601 3.68295 4.75001 4.09595 4.75001H13.1899C13.6039 4.75001 13.9399 4.41401 13.9399 4.00001C13.9399 3.58601 13.6039 3.25001 13.1899 3.25001H4.09595C2.85595 3.25001 1.84595 4.26001 1.84595 5.50001V18.955C1.84595 20.195 2.85595 21.205 4.09595 21.205H18.5759C19.8159 21.205 20.8259 20.195 20.8259 18.955V10.877C20.8259 10.462 20.4889 10.127 20.0759 10.127L20.0749 10.126Z"
          fill="black"
        />
      </svg>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Head',
  props: {
    backArrow: {
      type: Boolean,
      default: false,
    },
    message: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: 'loading',
      required: true,
    },
    count: {
      type: [String, Number],
      default: '',
    },
    account: {
      type: String,
    },
  },
  methods: {
    handleBack() {
      this.$router.back()
    },
  },
}
</script>

<style lang="scss" scoped>
@import '../assets/styles/mixin.scss';
.head {
  position: sticky;
  top: 0;
  z-index: 3;
  display: flex;
  align-items: center;
  height: 56px;
  text-align: left;
  background-color: var(--white);
  border-bottom: 1px solid var(--blue-gray-600);
  font-weight: bold;
  padding: 0 12px;
  cursor: pointer;
  &__back {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 32px;
    height: 32px;
    margin-right: 16px;
    border-radius: 16px;
    cursor: pointer;
    transition-duration: 0.2s;
    transition-property: background-color;
    &:hover {
      background-color: var(--gray-100);
    }
    &__icon {
      width: 24px;
      height: 24px;
    }
  }
  &__info {
    display: flex;
    flex-direction: column;
    margin-left: 16px;
    &__title {
      white-space: nowrap;
      max-width: 300px;
      overflow: hidden;
      text-overflow: ellipsis;
      @include font-setting(18px, 900, var(--text));
    }
    &__count,
    &__account {
      line-height: 13px;
      @include font-setting(13px, 500, var(--gray-500));
    }
  }
  &__message {
    position: absolute;
    right: 15px;
    display: flex;
    align-items: center;
  }
}
</style>
